import { createFileRoute } from '@tanstack/react-router'
import { LotoReportPage } from 'pages/lotoReports/LotoReportPage'

function RouteComponent() {
  const { reportId } = Route.useParams()
  return <LotoReportPage reportId={reportId} />
}

export const Route = createFileRoute('/loto-reports/$reportId')({
  component: RouteComponent,
  staticData: {
    title: 'LOTO Report',
    layout: {
      enableScrolling: true,
    },
  },
})
